import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ae0002',
    ecrans: ['00-2']
});
